"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Farm_1 = __importDefault(require("../models/Farm"));
const Farm_2 = require("../models/Farm");
const MetadataLibrary_1 = __importDefault(require("../models/MetadataLibrary"));
const FarmListService_1 = __importDefault(require("../services/FarmListService"));
class FarmListController {
    constructor() {
        this.farms = [];
        this.currentPage = 1;
        this.service = new FarmListService_1.default();
        this.farmsPages = [];
        this.farmsCurrentPage = [];
        this.totalFarms = 1;
        this.activeFarm = new Farm_1.default({
            id: -1,
            name: '-',
            created_at: '-',
            client_name: '-',
            client_code: '-',
            total_fields: -1,
            total_extension: -1,
            preferred_unit: '-',
            gis_fields: [],
            geodata: '-'
        });
        this.historicFarm = new Farm_2.HistoricalFarm({
            'times': [],
            'farmHistory': new Array()
        });
        this.library = new MetadataLibrary_1.default();
    }
    static getInstance() {
        if (this._instance)
            return this._instance;
        this._instance = new FarmListController();
        return this._instance;
    }
    async getFarms(page, farmId) {
        this.currentPage = page;
        await this.service.fetchFarms(page, farmId);
        this.farms = this.service.farms;
        this.totalFarms = this.service.totalFarms;
        this.farmsPages.push({ page: this.currentPage, farms: this.service.farmsPages });
        this.farmsCurrentPage = this.service.farmsPages;
    }
    async preloadNextPages() {
        const endPage = this.service.totalPages;
        for (let page = 2; page <= endPage; page++) {
            const alreadyCached = this.farmsPages.some(p => p.page === page);
            if (alreadyCached)
                continue;
            try {
                await this.service.fetchFarms(page, null, true);
                this.farmsPages.push({ page, farms: [...this.service.farmsPages] });
            }
            catch (error) {
                console.warn(`Error preloading page ${page}:`, error);
            }
        }
        return true;
    }
    async changeFarmListPage(newPage, farmId = null) {
        await this.getFarms(newPage, farmId);
    }
    async fetchLibrary() {
        try {
            const library = await this.service.fetchLibrary();
            if (library) {
                this.setLibrary(library);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchFarmHistory(farmId) {
        try {
            const farmHistoryFormatted = await this.service.fetchFarmHistory(farmId);
            if (farmHistoryFormatted) {
                this.historicFarm = farmHistoryFormatted;
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async editFarmName(newName, farm) {
        try {
            if (newName !== farm.name) {
                const resp = await this.service.editFarmName(newName, farm);
                if (resp.status === 200) {
                    this.activeFarm.name = newName;
                }
                else {
                    this.activeFarm.name = farm.name;
                }
                return resp;
            }
        }
        catch (e) {
            return e;
        }
    }
    async removeField(f) {
        try {
            const resp = await this.service.removeField(this.activeFarm.id, f.id, f.gfId);
            if (resp.status === 200) {
                this.removeFieldFromModel(f.id);
            }
            return resp;
        }
        catch (e) {
            return e;
        }
    }
    removeFieldFromModel(id) {
        this.activeFarm.gis_fields = this.activeFarm.gis_fields.filter((gf) => gf.id !== id);
    }
    async updateField(f) {
        try {
            const resp = await this.service.updateField(this.activeFarm.id, f);
            if (resp.status === 200) {
                this.activeFarm.updateField(f);
            }
            return resp;
        }
        catch (e) {
            return e;
        }
    }
    removeFarmFromModel(id) {
        this.farms = this.farms.filter((f) => f.id !== id);
        this.farmsCurrentPage = this.farmsCurrentPage.filter((f) => f.id !== id);
        this.farmsPages[this.currentPage - 1].farms = this.farmsPages[this.currentPage - 1].farms.filter((f) => f.id !== id);
    }
    async removeFarm(f) {
        try {
            const resp = await this.service.removeFarm(f.id);
            if (resp.status === 200) {
                this.removeFarmFromModel(f.id);
            }
            return resp;
        }
        catch (e) {
            return e;
        }
    }
    isTimeLocked(s) {
        const historicFarm = this.historicFarm.farmHistory.find((f) => f.date === s);
        if (historicFarm) {
            return historicFarm.locked;
        }
        return false;
    }
    addNewField() {
        window.location.href = `/map_setup_activation?farm_id=${this.activeFarm.id}`;
    }
    setLibrary(l) {
        this.library.setCrops(l.crops);
        this.library.setPractices(l.practices);
        this.library.setArtificialIrrigationTypes(l.artificialIrrigationTypes);
        this.library.setArtificialIrrigationUsages(l.artificialIrrigationUsages);
    }
    setActiveFarmFromHistory() {
        if (this.historicFarm.farmHistory.length > 0) {
            const activeFarm = this.historicFarm.farmHistory.find((f) => f.active);
            if (activeFarm) {
                this.activeFarm = activeFarm;
            }
        }
    }
    setActiveFarmTime(time) {
        const activeFarm = this.historicFarm.farmHistory.find((f) => f.date === time);
        if (activeFarm) {
            this.activeFarm = activeFarm;
        }
    }
    setInitialFarm() {
        const currentURLString = new URL(window.location.href).searchParams;
        const farmId = currentURLString.get('farmId') || null;
        if (farmId) {
            const farm = this.farms.find((f) => f.id === parseInt(farmId));
            if (farm)
                this.activeFarm = farm;
            return;
        }
        if (this.farms.length > 0)
            this.activeFarm = this.farms[0];
    }
    setActiveFarm(f) {
        this.activeFarm = f;
        const url = new URL(window.location.href);
        url.searchParams.set('farmId', f.id.toString());
        window.history.replaceState({}, '', url.href);
    }
    get loading() {
        return this.service.loading;
    }
    get HA_THRESHOLD() {
        return 150;
    }
    get AC_THRESHOLD() {
        return 370;
    }
    get customQuotableFarms() {
        const HA_THRESHOLD = this.HA_THRESHOLD;
        const AC_THRESHOLD = this.AC_THRESHOLD;
        return this.farms.filter((f) => {
            if (f.preferred_unit.toLowerCase().startsWith('h')) {
                if (f.total_extension > HA_THRESHOLD) {
                    return true;
                }
                else {
                    return false;
                }
            }
            if (f.preferred_unit.toLowerCase().startsWith('a')) {
                if (f.total_extension > AC_THRESHOLD) {
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
}
exports.default = FarmListController;
